/**
 * Linear interpolation between two ranges
 * @param {number} input - The input value to interpolate
 * @param {number} inputMin - Minimum of input range
 * @param {number} inputMax - Maximum of input range
 * @param {number} outputMin - Minimum of output range
 * @param {number} outputMax - Maximum of output range
 * @returns {number} The interpolated value in the output range
 */
export function lerp(input, inputMin, inputMax, outputMin, outputMax) {
  const normalized = (input - inputMin) / (inputMax - inputMin);
  return outputMin + normalized * (outputMax - outputMin);
}
